import React from "react";
import { MenuItem, Typography } from "@mui/material";
import type { SequenceView } from "@services/drybulkCargoOperationsApi";
import { useTranslation } from "react-i18next";
import { DRYBULK_CARGO_OPS_LANG_BASE } from "../constants";
import { executionActions } from "../utils/executionActions";
import { useExecution } from "./executionContext";

const L = `${DRYBULK_CARGO_OPS_LANG_BASE}.sequences.execution.actions`;

/**
 * DBCO-0048 - the execution items of a sequence row's menu (Operations): Add additional data, Start Sequence, Add Increment,
 * Complete Increment (Start is shown disabled with its reason while the Shipper readiness gate holds). Which of them is offered follows the statuses and increments the server returned (display only;
 * the server enforces every window and its refusal is rendered).
 */
const ExecutionRowItems: React.FC<{
  sequence: SequenceView;
  operationStatus: string | null;
}> = ({ sequence, operationStatus }) => {
  const { t } = useTranslation();
  const { open } = useExecution();
  const actions = executionActions(sequence, operationStatus);
  return (
    <>
      {actions.equipment && (
        <MenuItem
          data-testid={`sequence-equipment-${sequence.id}`}
          onClick={() => open("equipment", sequence)}
        >
          {t(`${L}.equipment`)}
        </MenuItem>
      )}
      {actions.start && (
        <MenuItem
          data-testid={`sequence-start-${sequence.id}`}
          onClick={() => open("start", sequence)}
        >
          {t(`${L}.start`)}
        </MenuItem>
      )}
      {actions.startBlocked && (
        <MenuItem data-testid={`sequence-start-${sequence.id}`} disabled sx={{ display: "block" }}>
          {t(`${L}.start`)}
          <Typography variant="caption" color="text.secondary" display="block">
            {t(`${L}.start-blocked.${actions.startBlocked}`)}
          </Typography>
        </MenuItem>
      )}
      {actions.add && (
        <MenuItem data-testid={`sequence-add-${sequence.id}`} onClick={() => open("add", sequence)}>
          {t(`${L}.add`)}
        </MenuItem>
      )}
      {actions.complete && (
        <MenuItem
          data-testid={`sequence-complete-${sequence.id}`}
          onClick={() => open("complete", sequence, actions.complete ?? undefined)}
        >
          {t(`${L}.complete`)}
        </MenuItem>
      )}
    </>
  );
};

export default ExecutionRowItems;
